import { Button, MobileStepper } from '@material-ui/core'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import { withTranslation } from 'react-i18next'

function ActionsBar({
  maxSteps,
  activeStep,
  handleResume,
  handleNext,
  handleBack,
  numAnswers,
  t
}) {
  return (
    <MobileStepper
      steps={maxSteps}
      position='static'
      variant='dots'
      activeStep={activeStep}
      nextButton={
        activeStep === maxSteps - 1 ?
          <Button size="small" onClick={handleResume} disabled={numAnswers === 0}>
            {t('resume')}
            <KeyboardArrowRight />
          </Button>
          :
          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
            {t('next')}
            <KeyboardArrowRight />
          </Button>
      }
      backButton={
        <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
          <KeyboardArrowLeft />
          {t('back')}
        </Button>
      }
    />
  )
}

export default withTranslation()(ActionsBar)